import React from 'react';
import PageBase from '../../../widgets/PageBase/PageBase';
import RaisedButton from 'material-ui/RaisedButton';
import ItemIcon from '../../../widgets/MRS/ItemIcon';
import {
  getFullItemName,
  isItemDispenser,
  getFrequencyOptions,
  getRateForFrequency
} from '../../../../utils/mrs-util';
import { formatNumber } from '../../../../utils/format-number-util';
import './EditItem.css';

class EditItemPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        frequency: props.lineItem.frequency,
        quantity: props.lineItem.quantity,
        adjustedPrice: props.lineItem.originalPrice.priceItem,
        total: this.getInitialTotal()
      }
    };
  }

  getInitialTotal = () => {
    return (
      this.props.lineItem.originalPrice.priceItem * this.props.lineItem.quantity
    );
  };

  calcTotal = () => {
    this.setState((prev) => ({
      form: {
        ...prev.form,
        total: prev.form.quantity * prev.form.adjustedPrice
      }
    }));
  };

  handleChange = (e) => {
    let adjustedPrice = this.state.form.adjustedPrice;
    if (e.target.name == 'frequency') {
      adjustedPrice = getRateForFrequency(this.props.item, e.target.value, this.props.customer.mrsCustomer.minFrequency);
    }
    this.setState(
      (prev) => ({
        form: { ...prev.form, [e.target.name]: e.target.value, adjustedPrice }
      }),
      this.calcTotal
    );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.handleSave(this.state.form);
  };

  render() {
    return (
      <div>
        <PageBase navigation={['MRS']} includeInactiveBranches>
          <form onSubmit={this.handleSubmit}>
            <div className="edit-item-form-fields">
              <div className="edit-item-info-container">
                <div style={{ marginRight: 30 }}>
                  <ItemIcon item={this.props.item} />
                </div>
                <div>
                  <div>{getFullItemName(this.props.item)}</div>
                  <div>{this.props.item.description}</div>
                </div>
              </div>
              <div className="edit-item-field-container">
                <div>
                  <div>Kit Freq:</div>
                  <input
                    name="initial_frequency"
                    value={this.props.lineItem.frequency}
                    className="edit-item-input"
                    disabled
                    readOnly
                  />
                </div>
                <div className="edit-item-field-right">
                  <div>New Kit Freq:</div>
                  <select
                    name="frequency"
                    value={this.state.form.frequency}
                    onChange={this.handleChange}
                    className="edit-item-input"
                    disabled={isItemDispenser(this.props.item)}
                  >
                    {isItemDispenser(this.props.item) ? (
                      <option value={0}>0</option>
                    ) : null}
                    {
                      getFrequencyOptions(this.props.customer.mrsCustomer.minFrequency).map((freq) => (
                      <option key={freq} value={freq}>
                        {freq.substring(1)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="edit-item-field-container">
                <div>
                  <div>Rate:</div>
                  <input
                    name="initial_rate"
                    value={`$${formatNumber(
                      this.props.lineItem.originalPrice.priceItem,
                      2
                    )}`}
                    className="edit-item-input"
                    disabled
                    readOnly
                  />
                </div>
                <div className="edit-item-field-right">
                  <div>New Rate:</div>
                  <input
                    name="rate"
                    value={`$${formatNumber(this.state.form.adjustedPrice, 2)}`}
                    className="edit-item-input"
                    disabled
                    readOnly
                  />
                </div>
              </div>
              <div className="edit-item-field-container">
                <div>
                  <div>Qty:</div>
                  <input
                    name="initial_quantity"
                    value={this.props.lineItem.quantity}
                    className="edit-item-input"
                    disabled
                    readOnly
                  />
                </div>
                <div className="edit-item-field-right">
                  <div>New Qty:</div>
                  <input
                    name="quantity"
                    value={this.state.form.quantity}
                    onChange={this.handleChange}
                    type="number"
                    className="edit-item-input"
                  />
                </div>
              </div>
              <div className="edit-item-field-container">
                <div>
                  <div>Total:</div>
                  <input
                    name="initial_total"
                    value={`$${formatNumber(this.getInitialTotal(), 2)}`}
                    className="edit-item-input"
                    disabled
                    readOnly
                  />
                </div>
                <div className="edit-item-field-right">
                  <div>New Total:</div>
                  <input
                    name="total"
                    value={`$${formatNumber(this.state.form.total, 2)}`}
                    className="edit-item-input"
                    disabled
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="edit-item-actions-container">
              <div>
                <RaisedButton
                  label="Cancel"
                  primary
                  onClick={this.props.handleCancel}
                />
              </div>
              <div>
                <RaisedButton label="Save" primary type="submit" />
              </div>
            </div>
          </form>
        </PageBase>
      </div>
    );
  }
}

export default EditItemPage;
